<template>
  <div>
    <br/><br/><br/><br/>
    <h1>not found</h1>

  </div>
</template>

<script>

  export default {
    name: 'not-found',
    components: {
    },
    props: {
    },
    data() {
        return {}
    },
    created()
    {

    },
    mounted() {

    },
    methods:{

    },
    computed: {

    }
  }
</script>

<style lang="scss">


</style>